import { Observable } from 'rxjs';

import { HttpHandler, HttpRequest, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { SN_API_URL } from '../providers/api-url.provider';

@Injectable()
export class SnApiUrlInterceptor implements HttpInterceptor {
  constructor(@Inject(SN_API_URL) private readonly _apiUrl: string) {}

  public intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith('/api')) {
      return handler.handle(request);
    }

    return handler.handle(this._applyApiUrl(request));
  }

  private _applyApiUrl(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      url: this._apiUrl + request.url,
    });
  }
}
